import { post, get } from './request.js';

const site_id = 2;

export default {
    /* 全局信息 */
    common() {
        return post("/home/common", { site_id })
    },

    /* 首页信息 */
    homeIndex() {
        return post("/home/index", { site_id })
    },

    /* 判断是不是国外 */
    ipregion() {
        return post("/home/ipregion", { site_id })
    },

    /* 关于海玛 */
    /* 企业介绍 */
    aboutIndex() {
        return post("/about/index", { site_id })
    },
    /* 荣誉资质 */
    aboutHonor(data = { page: 1 }) {
        return post("/about/honor", { ...data, site_id })
    },
    /* 发展历程 */
    aboutHistory() {
        return post("/about/history", { site_id })
    },
    /* 合作伙伴 */
    aboutPartners(data = {}) {
        return post("/about/partners", { ...data, site_id })
    },

    /* 海玛产品 */
    /* 产品列表 */
    productIndex(data = { page: 1, cid: 1 }) {
        return post("/product/index", { ...data, site_id })
    },
    /* 产品详情 */
    productInfo(data = { id: 1 }) {
        return post("/product/info", { ...data, site_id })
    },

    /* 解决方案 */
    /* 方案详情 */
    solutionIndex(data = { id: 1 }) {
        return post("/solution/index", { ...data, site_id })
    },

    /* 经典案例 */
    /* 案例列表 */
    casesIndex(data = { page: 1, industry_id: 1 }) {
        return post("/cases/index", { ...data, site_id })
    },
    /* 案例详情 */
    casesInfo(data = { id: 1 }) {
        return post("/cases/caseinfo", { ...data, site_id })
    },

    /* 媒体中心 */
    /* 新闻列表 */
    newsIndex(data = { page: 1, cid: 1 }) {
        return post("/news/index", { ...data, site_id })
    },
    /* 新闻详情 */
    newsInfo(data = { id: 1 }) {
        return post("/news/info", { ...data, site_id })
    },

    /* 联系我们 */
    /* 人才理念 */
    contactIndex() {
        return post("/contact/index", { site_id })
    },
    /* 人才招聘 */
    contactJoblist() {
        return post("/contact/joblist", { site_id })
    },
    /* 联系我们 */
    contactContact() {
        return post("/contact/contact", { site_id })
    },
    /* 留言提交 */
    contactPostmsg(data = { name: "" }) {
        return post("/contact/postmsg", { ...data, site_id })
    }
}